import * as React from 'react'

import { CollapseButton } from '~/client/src/shared/components/CollapseButton/CollapseButton'
import { CHECKBOX_COLUMN_WIDTH } from '~/client/src/shared/components/SharedVirtualTable/columns'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import type { UseTableListResult } from './useTableList'

interface IListSelectionToolbarProps<T> {
  readonly list: UseTableListResult<T>
  readonly countLabel: string
  readonly selectionActions: React.ReactNode
  readonly children?: React.ReactNode
}

export default function ListSelectionToolbar<T>({
  list,
  countLabel,
  selectionActions,
  children,
}: IListSelectionToolbarProps<T>): React.ReactElement {
  const t = Localization.translator
  const { selection, bands } = list
  const filteredCount = list.model.filteredCount
  const hasSelection = selection.count > 0
  const canCollapse = !!bands.activeGroupKey

  return (
    <div className="tw:flex tw:items-center tw:gap-2 tw:px-4 tw:py-2">
      {canCollapse && (
        <div
          className="tw:-ml-4 tw:flex tw:shrink-0 tw:items-center tw:justify-center"
          style={{ width: CHECKBOX_COLUMN_WIDTH }}
        >
          <CollapseButton
            isExpanded={!bands.isAllCollapsed}
            onClick={bands.toggleAll}
            ariaLabel={bands.isAllCollapsed ? t.expandAll : t.collapseAll}
          />
        </div>
      )}
      <span className="tw:shrink-0 tw:text-body-md tw:whitespace-nowrap tw:text-muted-foreground">
        {hasSelection
          ? t.xOfYSelected(selection.count, filteredCount)
          : countLabel}
      </span>
      <div className="tw:flex tw:min-w-0 tw:flex-1 tw:items-center tw:gap-2 tw:overflow-hidden">
        {hasSelection && selectionActions}
      </div>
      {children != null && (
        <div className="tw:flex tw:shrink-0 tw:items-center tw:gap-2">
          {children}
        </div>
      )}
    </div>
  )
}
